import { v4 as uuidv4 } from "uuid";

function recursiveGetEventIds(uniqueId: string, eventData: any): any {
  const idMapping: any = {};
  const _recursive = (data: any) => {
    if (typeof data !== "object") {
      return data;
    }
    const obj = { ...data };

    Object.values(obj).forEach((val) => {
      if (
        typeof val === "string" &&
        (val === "e" ||
          val === "a" ||
          val.startsWith("e-") ||
          val.startsWith("a-"))
      ) {
        idMapping[val] = `${uniqueId}-${val}`;
      } else if (Array.isArray(val)) {
        val.map((e) => _recursive(e));
      } else if (typeof val === "object") {
        _recursive(val);
      }
    });
  };
  _recursive(eventData);
  return idMapping;
}

function recursiveUpdateValues(data: any, idMapping: any): any {
  if (data === null) {
    return null;
  }
  if (typeof data !== "object") {
    return data;
  }
  const obj = { ...data };

  Object.entries(obj).forEach((entry) => {
    const val = entry[1];
    const key = entry[0];

    if (typeof val === "string" && typeof idMapping[val] === "string") {
      obj[key] = idMapping[val];
    } else if (Array.isArray(val)) {
      obj[key] = val.map((e) => recursiveUpdateValues(e, idMapping));
    } else if (typeof val === "object") {
      obj[key] = recursiveUpdateValues(val, idMapping);
    }

    if (typeof idMapping[key] === "string") {
      obj[idMapping[key]] = obj[key];
      delete obj[key];
    }
  });
  return obj;
}

type Events = any & { zilchEventId: string };
export function makeEventsUnique(data: any): Events {
  const uniqueId = uuidv4();
  const eventData = { ...data, zilchEventId: uniqueId };

  let eventIdMapping: any = {};
  let actionListIdMapping: any = {};

  Object.entries(eventData?.events ?? {}).forEach((event) => {
    eventIdMapping[event[0]] = `${uniqueId}-${event[0]}`;
    eventIdMapping = {
      ...eventIdMapping,
      ...recursiveGetEventIds(uniqueId, event[1]),
    };
  });
  Object.entries(eventData?.actionLists ?? {}).forEach((action) => {
    actionListIdMapping[action[0]] = `${uniqueId}-${action[0]}`;
    actionListIdMapping = {
      ...actionListIdMapping,
      ...recursiveGetEventIds(uniqueId, action[1]),
    };
  });

  // Now walk through both lists to update the id's being referred to
  const events = recursiveUpdateValues(eventData?.events ?? {}, eventIdMapping);
  eventData.events = recursiveUpdateValues(events, actionListIdMapping);

  const actionLists = recursiveUpdateValues(
    eventData?.actionLists ?? {},
    actionListIdMapping
  );
  eventData.actionLists = recursiveUpdateValues(actionLists, eventIdMapping);

  return eventData;
}
